<app-nav-steps *ngIf="!isReadOnly"></app-nav-steps>

<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="page-heading text-center text-uppercase">
      {{ 'installation-data.feed-in-system' | translate }}
      <span *ngIf="isReadOnly">- {{ 'overview.jurisdiction-overview.application_id' | translate }} {{ externalApplicationId }}</span>
    </div>
  </div>

  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align text-uppercase page-title">
      {{ 'technician-data.technical-data-title' | translate }} -
      {{ 'lookup.' + feedInTypeKey + '.options.' + feedInInstallationType + '.name' | translate }}
    </div>
  </div>
  <div *ngIf="technicalDataFG" class="technical-data-form-container">
    <form [formGroup]="technicalDataFG" class="form-section form-font-size">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header
          [title]="'technical-data.system-type' | translate"
          [tooltip]="'tooltips.technical-data.system-type' | translate"
          [showTooltip]="infoBubblesData?.showSystemTypeInfo"></app-section-header>
      </div>
      <div class="form-background margin-align">
        <div class="top-bottom-margin">
          <div *ngFor="let attachment of attachments.controls; index as i" formArrayName="attachments">
            <div [formGroupName]="i" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows">
              <div class="ui-g-5 ui-xl-5 ui-lg-5 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required">{{ 'technical-data.system' | translate }}</label>
                <p-dropdown
                  #systemType
                  [readonly]="isReadOnly"
                  [options]="feedInSystems"
                  formControlName="systemType"
                  optionLabel="label"
                  placeholder="-Select-"></p-dropdown>
              </div>
              <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-5 field-label text-right-align required" for="attachment-system-max-power">
                  {{ getFacilitySystemPowerLabel(systemType.value.value) | translate }}
                </label>
                <input
                  appFloatNumber="2"
                  class="small-width"
                  formControlName="systemMaxPower"
                  pInputText
                  [readonly]="isReadOnly"
                  id="attachment-system-max-power" />
                <span class="unit-margin">{{ allUnits.power }}</span>
              </div>
              <div
                (click)="removeEntity('attachments', i)"
                *ngIf="!isReadOnly && attachments.controls?.length > 1"
                class="pi pi-trash pointer-cursor right-aligned ui-g-1"></div>
            </div>
          </div>
          <div *ngIf="!isReadOnly" class="ui-g-12 add-button-row top-border">
            <div class="empty-container"></div>
            <i (click)="addEntity('attachments')" class="pi pi-plus plus-icon"></i>
            <label class="ui-g-5 field-label">{{ 'technical-data.add-attachment' | translate }}</label>
          </div>
        </div>
        <div class="top-bottom-margin">
          <div *ngFor="let inverter of inverters.controls; index as i" formArrayName="inverters">
            <div [formGroupName]="i" class="ui-g form-rows">
              <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-12 field-label text-right-align">{{ 'technical-data.inverter' | translate }} {{ i + 1 }}</label>
              </div>

              <div class="ui-g-9">
                <div class="ui-g-12 field-rows">
                  <div *ngIf="showManufacturerAndType" class="ui-g-6 field-rows">
                    <label for="attachment-manufacturer" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.manufacturer' | translate }}
                    </label>
                    <input id="attachment-manufacturer" formControlName="manufacturer" pInputText type="text" [readonly]="isReadOnly" />
                  </div>
                  <div class="ui-g-6 field-rows">
                    <label for="attachment-no-of-units" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.no_of_units' | translate }}
                    </label>
                    <input
                      id="attachment-no-of-units"
                      class="small-width"
                      formControlName="no_of_units"
                      pInputText
                      type="number"
                      [readonly]="isReadOnly" />
                  </div>
                </div>
                <div class="ui-g-12 field-rows padding-top-2">
                  <div *ngIf="showManufacturerAndType" class="ui-g-6 field-rows">
                    <label for="attachment-type" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.type' | translate }}
                    </label>
                    <input id="attachment-type" formControlName="type" pInputText type="text" [readonly]="isReadOnly" />
                  </div>
                  <div class="ui-g-6 field-rows">
                    <label for="attachment-max-power" class="ui-g-6 field-label text-right-align">
                      {{ 'technical-data.max-power-inverter-label' | translate }}
                    </label>
                    <input
                      id="attachment-max-power"
                      [appFloatNumber]="floatNumberFeedinSystemMaxPower"
                      class="small-width"
                      formControlName="max_power"
                      pInputText
                      [readonly]="isReadOnly" />
                    <span class="unit-margin">{{ allUnits.power }}</span>
                  </div>
                </div>
              </div>
              <div
                (click)="removeEntity('inverters', i)"
                *ngIf="!isReadOnly && inverters.controls?.length > 1"
                class="pi pi-trash pointer-cursor right-aligned ui-g-1"></div>
            </div>
          </div>
          <div *ngIf="!isReadOnly" class="ui-g-12 add-button-row top-border">
            <div class="empty-container"></div>
            <i (click)="addEntity('inverters')" class="pi pi-plus plus-icon"></i>
            <label class="ui-g-5 field-label">{{ 'technical-data.add-inverter' | translate }}</label>
          </div>
        </div>
        <div class="top-bottom-margin">
          <div *ngFor="let generator of generators.controls; index as i" formArrayName="generators">
            <div [formGroupName]="i" class="ui-g form-rows">
              <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-12 field-label text-right-align">{{ 'technical-data.generator' | translate }} {{ i + 1 }}</label>
              </div>

              <div class="ui-g-9">
                <div class="ui-g-12 field-rows">
                  <div *ngIf="showManufacturerAndType" class="ui-g-6 field-rows">
                    <label for="generator-manufacturer" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.manufacturer' | translate }}
                    </label>
                    <input id="generator-manufacturer" formControlName="manufacturer" pInputText type="text" [readonly]="isReadOnly" />
                  </div>
                  <div class="ui-g-6 field-rows">
                    <label for="generator-no-of-units" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.no_of_units' | translate }}
                    </label>
                    <input
                      id="generator-no-of-units"
                      class="small-width"
                      formControlName="no_of_units"
                      pInputText
                      type="number"
                      [readonly]="isReadOnly" />
                  </div>
                </div>
                <div class="ui-g-12 field-rows padding-top-2">
                  <div *ngIf="showManufacturerAndType" class="ui-g-6 field-rows">
                    <label for="generator-type" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.type' | translate }}
                    </label>
                    <input id="generator-type" formControlName="type" pInputText type="text" [readonly]="isReadOnly" />
                  </div>
                  <div class="ui-g-6 field-rows">
                    <label for="generator-max-power" class="ui-g-6 field-label text-right-align">
                      {{ 'technical-data.max-power-generator-label' | translate }}
                    </label>
                    <input
                      id="generator-max-power"
                      [appFloatNumber]="floatNumberFeedinSystemMaxPower"
                      class="small-width"
                      formControlName="max_power"
                      pInputText />
                    <span class="unit-margin">
                      {{ generatorPowerInWatts ? allUnits.wattPowerUnit : allUnits.kilowattPowerUnit }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                (click)="removeEntity('generators', i)"
                *ngIf="!isReadOnly && generators.controls?.length > 1"
                class="pi pi-trash pointer-cursor right-aligned ui-g-1"></div>
            </div>
          </div>
          <div *ngIf="!isReadOnly" class="ui-g-12 add-button-row top-border">
            <div class="empty-container"></div>
            <i (click)="addEntity('generators')" class="pi pi-plus plus-icon"></i>
            <label class="ui-g-5 field-label">{{ 'technical-data.add-generator' | translate }}</label>
          </div>
        </div>
        <div class="top-bottom-margin">
          <div *ngFor="let storage of storages.controls; index as i" formArrayName="storages">
            <div [formGroupName]="i" class="ui-g form-rows">
              <div class="ui-g-2 ui-xl-2 ui-lg-2 ui-md-2 ui-sm-12 ui-xs-12 field-rows">
                <label class="ui-g-12 field-label text-right-align">{{ 'technical-data.storage' | translate }} {{ i + 1 }}</label>
              </div>

              <div class="ui-g-9">
                <div class="ui-g-12 field-rows">
                  <div *ngIf="showManufacturerAndType" class="ui-g-6 field-rows">
                    <label for="storage-manufacturer" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.manufacturer' | translate }}
                    </label>
                    <input id="storage-manufacturer" formControlName="manufacturer" pInputText type="text" [readonly]="isReadOnly" />
                  </div>
                  <div class="ui-g-6 field-rows">
                    <label for="storage-no-of-units" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.no_of_units' | translate }}
                    </label>
                    <input
                      id="storage-no-of-units"
                      class="small-width"
                      formControlName="no_of_units"
                      pInputText
                      type="number"
                      [readonly]="isReadOnly" />
                  </div>
                </div>
                <div class="ui-g-12 field-rows padding-top-2">
                  <div *ngIf="showManufacturerAndType" class="ui-g-6 field-rows">
                    <label for="storage-type" class="ui-g-6 field-label text-right-align required">
                      {{ 'technical-data.type' | translate }}
                    </label>
                    <input id="storage-type" formControlName="type" pInputText type="text" [readonly]="isReadOnly" />
                  </div>
                  <div class="ui-g-6 field-rows">
                    <label for="storage-max-power" class="ui-g-6 field-label text-right-align">
                      {{ 'technical-data.max-power-generator-label' | translate }}
                    </label>
                    <input
                      id="storage-max-power"
                      [appFloatNumber]="floatNumberFeedinSystemMaxPower"
                      class="small-width"
                      formControlName="max_power"
                      pInputText />
                    <span class="unit-margin">
                      {{ generatorPowerInWatts ? allUnits.wattPowerUnit : allUnits.kilowattPowerUnit }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                (click)="removeEntity('storages', i)"
                *ngIf="!isReadOnly && storages.controls?.length > 1"
                class="pi pi-trash pointer-cursor right-aligned ui-g-1"></div>
            </div>
          </div>
          <div *ngIf="!isReadOnly && showStorageSubsection" class="ui-g-12 add-button-row top-border">
            <div class="empty-container"></div>
            <i (click)="addEntity('storages')" class="pi pi-plus plus-icon"></i>
            <label class="ui-g-5 field-label">{{ 'technical-data.add-storage' | translate }}</label>
          </div>
        </div>
      </div>

      <div *ngIf="!hideSystemOperationSection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header
          [title]="'technical-data.system-operation' | translate"
          [tooltip]="'tooltips.technical-data.system-operation' | translate"
          [showTooltip]="infoBubblesData?.showSystemOperationInfo"></app-section-header>
      </div>
      <div *ngIf="!hideSystemOperationSection" class="form-background margin-align">
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
            <!-- <label class="ui-g-5"></label> -->
            <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12">
              <p-radioButton
                (onClick)="checkForOperationModes()"
                [formControl]="technicalDataFG.controls['feedInOperationMode']"
                [value]="operationMode.feedInExcess"
                name="feedInOperationMode"></p-radioButton>
              <label class="field-label">{{ 'technical-data.excess-energy-to-grid' | translate }}</label>
            </div>
            <div
              *ngIf="
                technicalDataFG.controls['feedInOperationMode'].value === operationMode.feedInExcess && technicalDataFG.get('feedInExcess')
              "
              class="inner-options"
              [ngClass]="switchFeedInSystemExcessEnergyRadioButtons ? 'switch-rows' : ''">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-radioButton
                  [formControl]="technicalDataFG.controls['feedInExcess']"
                  [value]="operationMode.feedIn70"
                  name="feedInOperationExcessMode"></p-radioButton>
                <label class="field-label">
                  {{
                    ('technical-data.feed-grid' | translate) !== 'technical-data.feed-grid'
                      ? ('technical-data.feed-grid' | translate)
                      : ('technical-data.feed-grid-70' | translate)
                  }}
                </label>
              </div>
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-radioButton
                  [formControl]="technicalDataFG.controls['feedInExcess']"
                  [value]="operationMode.feedIn100"
                  name="feedInOperationExcessMode"></p-radioButton>
                <label class="field-label">{{ 'technical-data.feed-grid-100' | translate }}</label>
              </div>
            </div>
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-checkbox [binary]="true" [formControl]="technicalDataFG.controls['alreadyExists']" [readonly]="isReadOnly"></p-checkbox>
            <label class="field-label">{{ 'technical-data.plant-already-exists' | translate }}</label>
          </div>
        </div>
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
            <!-- <label class="ui-g-5"></label> -->
            <p-radioButton
              (onClick)="checkForOperationModes()"
              [formControl]="technicalDataFG.controls['feedInOperationMode']"
              [value]="operationMode.feedInFull"
              name="feedInOperationMode"></p-radioButton>
            <label class="field-label">{{ 'technical-data.all-energy-to-grid' | translate }}</label>
            <div
              *ngIf="
                technicalDataFG.controls['feedInOperationMode'].value === operationMode.feedInFull && technicalDataFG.get('feedInFull')
              "
              class="inner-options">
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-radioButton
                  [formControl]="technicalDataFG.controls['feedInFull']"
                  [value]="operationMode.feedIn70"
                  name="feedInOperationFullMode"></p-radioButton>
                <label class="field-label">{{ 'technical-data.feed-grid-70' | translate }}</label>
              </div>
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-radioButton
                  [formControl]="technicalDataFG.controls['feedInFull']"
                  [value]="operationMode.feedIn60"
                  name="feedInOperationFullMode"></p-radioButton>
                <label class="field-label">{{ 'technical-data.feed-grid-60' | translate }}</label>
              </div>
              <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
                <p-radioButton
                  [formControl]="technicalDataFG.controls['feedInFull']"
                  [value]="operationMode.other"
                  name="feedInOperationFullMode"></p-radioButton>
                <label for="full-feedin-value" class="field-label">{{ 'technical-data.others' | translate }}</label>
                <input
                  [appNumber]="true"
                  [readonly]="isReadOnly"
                  class="h4-button-and-field ui-input pInputText filed-width small-field-width"
                  formControlName="otherFeedInValue"
                  id="full-feedin-value"
                  pInputText
                  size="30" />
                %
              </div>
            </div>
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-checkbox [binary]="true" [formControl]="technicalDataFG.controls['systemPlanned']" [readonly]="isReadOnly"></p-checkbox>
            <label class="field-label">{{ 'technical-data.system-planned' | translate }}</label>
          </div>
        </div>
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <!-- <label class="ui-g-5"></label> -->
            <p-radioButton
              (onClick)="checkForOperationModes()"
              [formControl]="technicalDataFG.controls['feedInOperationMode']"
              [value]="operationMode.islandMode"
              name="feedInOperationMode"></p-radioButton>
            <label class="field-label">{{ 'technical-data.plant-operated-island-mode' | translate }}</label>
          </div>
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <p-checkbox [binary]="true" [formControl]="technicalDataFG.controls['finalConsumers']" [readonly]="isReadOnly"></p-checkbox>
            <label class="field-label">{{ 'technical-data.final-consumers' | translate }}</label>
          </div>
        </div>
        <p
          *ngIf="
            (technicalDataFG.controls['feedInFull'] &&
              technicalDataFG.controls['feedInFull'].value === operationMode.other &&
              +technicalDataFG.controls['otherFeedInValue'].value > 70 &&
              technicalDataFG.controls['otherFeedInValue']) ||
            (technicalDataFG.controls['feedInExcess'] && technicalDataFG.controls['feedInExcess'].value === operationMode.feedIn100)
          ">
          {{ 'technical-data.limit-warning' | translate }}
        </p>
      </div>

      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header
          [title]="'technical-data.measure-concept' | translate"
          [tooltip]="'tooltips.technical-data.measure-concept' | translate"
          [showTooltip]="infoBubblesData?.showMeasureConceptInfo"></app-section-header>
      </div>
      <div class="form-background margin-align">
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5 field-label text-right-align" [ngClass]="isSelectionOfMeasuringConceptRequired ? 'required' : ''">
              {{ 'technical-data.select-concept' | translate }}
            </label>
            <p-dropdown
              [readonly]="isReadOnly"
              [options]="measuringConcepts"
              formControlName="concept"
              optionLabel="label"
              placeholder="-Select-"></p-dropdown>
          </div>

          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            {{ 'technical-data.disclaimer' | translate }}
          </div>
        </div>
        <div class="ui-g form-rows" *ngIf="technicalDataFG.get('altConcept')">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows">
            <label class="ui-g-5"></label>
            <p-checkbox
              [binary]="true"
              [formControl]="technicalDataFG.controls['altConcept']"
              [readonly]="isReadOnly"
              (onChange)="updateSelectionOfMeasuringConceptObligation()"></p-checkbox>
            <label class="field-label">{{ 'technical-data.alternative-concept' | translate }}</label>
          </div>
        </div>
      </div>
      <div *ngIf="!hideInstallationSection" class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
        <app-section-header
          [title]="'technical-data.installation' | translate"
          [tooltip]="'tooltips.technical-data.installation' | translate"
          [showTooltip]="infoBubblesData?.showInstallationHeaderInfo"></app-section-header>
      </div>
      <div *ngIf="!hideInstallationSection" class="form-background margin-align">
        <div class="ui-g form-rows">
          <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 field-rows for-screen">
            <label class="ui-g-5 field-label text-right-align" [ngClass]="setCommissioningDateNoneMandatory ? '' : 'required'">
              {{ 'technical-data.compensation_date' | translate }}
            </label>
            <p-calendar
              [dateFormat]="dateFormat.dateFormat"
              [locale]="'app.calendar-settings' | translate"
              [monthNavigator]="true"
              [placeholder]="dateFormat.placeholder"
              [yearNavigator]="true"
              class="doc-submit-datepicker ui-g-7"
              dateFormat="string"
              formControlName="compensation_date"
              id="compensation-date"
              inputId="basic"
              yearRange="1900:2080"></p-calendar>
          </div>

          <div class="ui-g-12 field-rows for-print">
            <label class="ui-g-4 field-label text-right-align" [ngClass]="setCommissioningDateNoneMandatory ? '' : 'required'">
              {{ 'technical-data.compensation_date' | translate }}
            </label>
            <p-calendar
              [dateFormat]="dateFormat.dateFormat"
              [locale]="'app.calendar-settings' | translate"
              [monthNavigator]="true"
              [placeholder]="dateFormat.placeholder"
              [yearNavigator]="true"
              dateFormat="string"
              formControlName="compensation_date"
              inputId="basic"
              yearRange="1900:2080"></p-calendar>
          </div>
        </div>
      </div>
      <div *ngIf="!isReadOnly && !isDetailsView" class="ui-g-12 submit-button-section bottom-padding">
        <div class="ui-g-6 button-group">
          <button
            (click)="saveFormData()"
            [disabled]="technicalDataFG.invalid"
            class="submit-button"
            label="{{ 'basic-profile.jurisdiction.proceed' | translate | uppercase }}"
            pButton></button>
        </div>
      </div>
    </form>
  </div>
</div>
<app-loader *ngIf="isLoading"></app-loader>
